import { BaseGridItem } from 'shared/types/desktop-grid'

import { wouldCollide } from './wouldCollide'

export const findNearestFreePosition = (
  items: BaseGridItem[],
  cols: number,
  rows: number,
  size: { width: number; height: number },
  preferred: { row: number; col: number },
  skipItemId?: string,
  maxRadius?: number
): { row: number; col: number } | null => {
  const maxRow = rows - size.height
  const maxCol = cols - size.width
  if (maxRow < 0 || maxCol < 0) return null

  const clamp = (value: number, min: number, max: number) =>
    Math.max(min, Math.min(max, value))

  const startRow = clamp(preferred.row, 0, maxRow)
  const startCol = clamp(preferred.col, 0, maxCol)

  // check the preferred spot first
  if (
    !wouldCollide(
      skipItemId ?? 'temp',
      { row: startRow, col: startCol },
      size,
      items
    )
  ) {
    return { row: startRow, col: startCol }
  }

  const searchLimit =
    maxRadius != null
      ? Math.max(0, Math.floor(maxRadius))
      : Math.max(rows, cols)
  for (let radius = 1; radius <= searchLimit; radius++) {
    for (let dr = -radius; dr <= radius; dr++) {
      const dcCandidates = [radius - Math.abs(dr), -(radius - Math.abs(dr))]
      for (const dc of dcCandidates) {
        const candidateRow = clamp(startRow + dr, 0, maxRow)
        const candidateCol = clamp(startCol + dc, 0, maxCol)
        if (
          !wouldCollide(
            skipItemId ?? 'temp',
            { row: candidateRow, col: candidateCol },
            size,
            items
          )
        ) {
          return { row: candidateRow, col: candidateCol }
        }
      }
    }
  }

  return null
}
